import React from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import InputName from "../../common/Input/InputName";
import InputNumber from "../../common/Input/InputPhNumber";

const AddUpdateUnRegisteredClinic = ({
  modalshow,
  setModalShow,
  formData,
  handleChange,
  setInputError,
  handleAddUpdate,
  isUpdateMode,
}) => {
  return (
    <>
      <Modal
        centered
        show={modalshow}
        onHide={() => setModalShow(false)}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {" "}
            {isUpdateMode
              ? "Update Unregistered Clinic"
              : "Add Unregistered Clinic"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="row">
              <div className="col-md-6">
                <InputName
                  name="clinicName"
                  value={formData?.clinicName}
                  onChange={handleChange}
                  label="Name"
                  required={true}
                  setInputNameError={setInputError}
                />
              </div>
              <div className="col-md-6">
                <InputNumber
                  name="phone"
                  value={formData?.phone}
                  onChange={handleChange}
                  label="Phone"
                  setInputNumberError={setInputError}
                />
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={() => setModalShow(false)}
            className="p-2"
          >
            Cancel
          </Button>
          <Button variant="danger" className="p-2" onClick={handleAddUpdate}>
            {isUpdateMode ? "Update" : "Add"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AddUpdateUnRegisteredClinic;
